<template>
  <div :class="!showFluid ? 'container' : ''">
    <b-nav pills>
      <b-nav-item @click="$router.push('/')" link-classes="pl-0">
        <font-awesome-icon size="xs" :icon="['fas', 'chevron-left']" />
        {{ $t("project.management") }}
      </b-nav-item>
      <b-nav-text class="ml-4 flex-grow-1">
        {{
          $t("header.project") +
          ": " +
          (project ? project.name : "") +
          " - " +
          $store.state.projects.project.number
        }}
      </b-nav-text>
      <b-nav-item v-if="!$store.getters['projects/disabled']" href="#edit">
        <font-awesome-icon align="right" :icon="['fas', 'cog']" />
      </b-nav-item>
    </b-nav>
  </div>
</template>

<script>
import { cloak } from "../keecloak";

export default {
  data: () => ({
    user: cloak.userInfo,
  }),
  computed: {
    showFluid() {
      if (this.$route.name == "shoppingCart") return false;
      return true;
    },
    project() {
      return this.$store.state.projects
        ? this.$store.state.projects.project
        : {};
    },
  },
};
</script>
